import axios from 'axios'
import Cookies from 'js-cookie'

import {
  CART_ID_COOKIE_NAME,
  REGION_COOKIE_NAME
} from 'scripts/react-components/shared/constants/cookies'
import {
  CART_ID_HEADER_NAME,
  REGION_HEADER_NAME,
  SCRF_TOKEN_HEADER_NAME
} from 'scripts/react-components/shared/constants/headers'

export const api = axios.create()

api.defaults.baseURL = window.env.baseHost

api.interceptors.request.use(
  request => {
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content')

    const region = Cookies.get(REGION_COOKIE_NAME)

    request.headers[SCRF_TOKEN_HEADER_NAME] = csrfToken
    request.headers[REGION_HEADER_NAME] = region

    const cartId = Cookies.get(CART_ID_COOKIE_NAME)

    if (cartId) {
      request.headers[CART_ID_HEADER_NAME] = cartId
    }

    return request
  },
  error => {
    return Promise.reject(error)
  }
)

const buildSignupHeaders = async ({ recaptchaToken, redirectTo }) => {
  const headers = {}

  if (redirectTo) {
    headers['Redirect-URL'] = redirectTo
  }

  if (recaptchaToken) {
    headers['G-Recaptcha'] = recaptchaToken
  }

  if (window.fpPromise) {
    const fingerprint = await window.fpPromise

    if (fingerprint?.get) {
      const fpConfigs = await fingerprint.get()

      if (fpConfigs?.requestId && fpConfigs?.visitorId) {
        headers['X-FingerPrint-RequestID'] = fpConfigs.requestId
        headers['X-FingerPrint-VisitorID'] = fpConfigs.visitorId
      }
    }
  }

  return headers
}

export const signup = async ({ data, redirectTo, recaptchaToken }) => {
  const response = await api
    .post('/api/boitata/v1/signup', data, {
      headers: await buildSignupHeaders({
        recaptchaToken,
        redirectTo
      })
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const signupCheckForm = async userInfo => {
  const response = await api
    .post('/api/v3/signup/check', userInfo)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const signupCompany = async ({ data, recaptchaToken }) => {
  const response = await api
    .post('/api/boitata/v1/company/signup', data, {
      headers: await buildSignupHeaders({ recaptchaToken })
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
